import {BulletinFilters, BulletinsActionType} from 'Agent/AgentForms/Bulletins/ducks/Bulletin';
import {BulletinsControllerApi} from 'Documents/api';
import {Sort} from 'Shared/components/PagedView/Table/Sort';
import {createAction} from 'Shared/utilities/actionCreator';
import {getDate} from 'Shared/utilities/addFilterParameters';
import axiosInstance from 'Shared/utilities/axiosInstance';
import {toFormattedDateAsISO} from 'Shared/utilities/DateFormatter';
import {getAxiosConfig, handleResponse, withCancellation} from 'Shared/utilities/fetchHelpers';

export const documentsRootUri = '/documents';
const bulletinsApi = new BulletinsControllerApi(undefined, 'api' + documentsRootUri, axiosInstance);

export const changeBulletinFilters = (filters: BulletinFilters) =>
  createAction(BulletinsActionType.CHANGE_BULLETINS_FILTERS, {filters});

export default {
  getBulletins: (filter?: BulletinFilters, sort?: Sort, isNewYork?: boolean) =>
    withCancellation(cancelToken => {
      return bulletinsApi.getBulletinsUsingGET(
        isNewYork,
        toFormattedDateAsISO(filter?.created?.endDate !== undefined ? getDate(filter?.created?.endDate) : ''),
        toFormattedDateAsISO(filter?.created?.startDate !== undefined ? getDate(filter?.created?.startDate) : ''),
        filter?.bulletinSubject.toString(),
        filter?.bulletinType.tag === 'SelectedOption' ? filter.bulletinType.value : '',
        filter?.channels?.tag === 'SelectedOption' ? filter.channels.value : '',
        toFormattedDateAsISO(filter?.emailed?.endDate !== undefined ? getDate(filter?.emailed?.endDate) : ''),
        toFormattedDateAsISO(filter?.emailed?.startDate !== undefined ? getDate(filter?.emailed?.startDate) : ''),
        filter?.pageNumber?.toString(),
        filter?.pageSize?.toString(),
        sort ? sort?.column.toString() : 'createdOn',
        sort ? sort?.direction.toString() : 'desc',
        undefined,
        getAxiosConfig(cancelToken)
      );
    }).then(handleResponse),
};
